import { Container } from '@mui/material'
import { ChevronRight } from 'react-feather'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import TableMui from 'src/components/TableMui'
import TextFieldMui from 'src/components/TextFieldMui'
import { actions } from 'src/features/basic-queries/BasicQueriesState'
import { AddressInfo as AddressInfoModel } from 'src/features/basic-queries/BasicQueriesTypes'
import { Inline } from 'src/features/basic-queries/components/BasicQuery.styles'
import { BasicQueriesHeader } from 'src/features/basic-queries/components/Header/Header'
import { State } from 'src/features/types'
import { useSelector } from 'src/utils/store'

interface FormType{
  address: string
}

export const AddressInfo = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const addressInfo = useSelector((state: State) => state.basicQuery.addressInfo)
  const { register, handleSubmit, formState: { errors } } = useForm<FormType>({ defaultValues: { address: addressInfo?.address ?? '' } })

  const onRowClick = (address: AddressInfoModel) => {
    history.push(`/basic-queries/address-info/${addressInfo?.address}/product/${address.product.codProduto}`)
  }

  const onSubmit = (form: FormType) => {
    dispatch(actions.getAddressInfo(form.address))
  }

  return (
    <Container>
      <BasicQueriesHeader title='Produtos no Endereço'/>
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextFieldMui
          inputProps={{ ...register('address', { required: true }) }}
          error={!!errors.address}
          name='address'
          label='address'
          testId='address'
          variant='outlined'
          autoFocus
          fullWidth
        />
      </form>

      {
        addressInfo && (
          <TableMui
            containerStyle={{ marginTop: '16px' }}
            flatTable
            columns={[
              { id: 'product.descProduto', label: 'Produto' },
              { id: 'quantity', label: 'Estoque' },
            ]}
            rows={addressInfo.productList.map(((item) => ({ ...item, quantity: <Inline>{item.quantity}<ChevronRight/> </Inline> })))}
            onRowClick={onRowClick}
          />
        )
      }
    </Container>
  )
}
